import { generateGeoJSON } from "./geoUtils";
import {
  IAftnMessage,
  INotam,
  TAftnContentType,
} from "@naviair-utm/node-shared-interfaces";
import {
  convertMessage,
  parseContent,
  parseHeader,
  parseLimits,
  parseQualificationLine,
  parseSchedule,
} from "./notamHelper";

export const notamParser = (message: string): IAftnMessage<INotam> => {
  // Clean
  message = message.replace(/\\n/g, "\n");
  let response: IAftnMessage<INotam> = {} as IAftnMessage<INotam>;
  response.rawInput = message;
  response.parsedMessage = {};
  response.errors = [];

  // Check input
  if (typeof message === "string" && message.trim() !== "") {
    let n = convertMessage(message);
    if (n != null) {
      let res: INotam = {
        header: parseHeader(n.header.trim()),
        qualification: parseQualificationLine(n.q),
        schedule: parseSchedule(n.b, n.c, n.d),
        content: parseContent(n.e),
      };
      if (n.f != null || n.g != null) res.limits = parseLimits(n.f, n.g);
      response.parsedMessage = res;
      response.type = res.header.type as TAftnContentType;
      response.parsedMessage.rawFields = n;

      // Set ICAO and FIR string
      response.icao = n.a;
      response.fir = res.qualification.location;

      //Set validity
      response.validity = {};
      if (res.schedule.activityStart) {
        response.validity.start = new Date(res.schedule.activityStart);
      }
      if (res.schedule.validityEnd) {
        response.validity.end = new Date(res.schedule.validityEnd);
      }
    } else {
      response.errors.push("Unable to convert input message");
    }
  } else {
    response.errors.push("Invalid input message");
  }

  //Generate GeoJSON output
  if (
    response.parsedMessage.content?.area ||
    response.parsedMessage.qualification?.coordinates
  ) {
    response.parsedMessage.geojson = generateGeoJSON(
      response.parsedMessage.content.area ?? [
        response.parsedMessage.qualification.coordinates,
      ],
      response.parsedMessage.qualification.coordinates.radius
    );
  }

  return response;
};

export const NotamDecoder = () => {
  return {
    decode: notamParser,
  };
};
